export let InstagramMediaType;(function(a){a.Album="CAROUSEL_ALBUM",a.Image="IMAGE"})(InstagramMediaType||(InstagramMediaType={}));